export default {
  error: (messageOrError) => {
    if (console.error) {
      console.error(messageOrError);
    } else if (console.log) {
      console.log(messageOrError);
    }
  },

  warning(message) {
    if (console.warn) {
      console.warn(message);
    } else if (console.log) {
      console.log(message);
    }
  }
}
